import React from 'react'
import TerminalButton from "../styledComponents/TerminalButton"
import Typewriter from "../../typewriter/typewriter-effect"
import { CONSTANTS } from "../../renegadeOSLite/constants"
import TerminalLoginCTA from "../styledComponents/terminalLogin/TerminalLoginCTA"
import NoteForComputerNerds from "./NoteForComputerNerds/NoteForComputerNerds"
import { makeStyles } from "@material-ui/core/styles"
import Grid from '@material-ui/core/Grid'
import VisibilitySensor from 'react-visibility-sensor'

const useStyles = makeStyles((theme) => ({
    buttonWrapper: {
        marginTop: 10
    }
}));

const ChunkDiv = (props) => {
    const {chunk, isActiveChunk, showButtons, handleButtonClick, tw, buttonText, logo, buttonsAreVisibleCallback} = props
    const classes = useStyles()
    const getButtons = () => {
        return chunk.buttons.map((btn, i) => {
            return  (
                    <Grid item xs={12} sm={chunk.buttons && chunk.buttons.length == 1 ? 12 : 6} key={i} id='buttons'>
                        <TerminalButton
                            i={i}
                            key={i}
                            handleClick={() => {
                                handleButtonClick({ buttonIndex: i, chunkUid: chunk.uid })}
                            }
                            isPillButton={chunk.isPillButton}
                            btn={btn}
                        />
                    </Grid>
            )
        })
    }

    const getAttachedComponent = () => {
        if (chunk.attachedComponent && chunk.attachedComponent === CONSTANTS.ATTACHED_COMPONENTS.NOTE_FOR_COMPUTER_NERDS) {
            return <NoteForComputerNerds />
        }
        else return null
    }

    const getChunkOfText = () => {
        const preResponse = chunk.nextState ? "" : "> "

        if (isActiveChunk) {
            if (chunk.typing) {
                return (
                    <VisibilitySensor
                        onChange={(isVisible) => {buttonsAreVisibleCallback(isVisible)}}
                        partialVisibility={true}
                    >
                        <Typewriter
                            onInit={tw.onInit}
                            options={tw.options}
                        />
                    </VisibilitySensor>
                )
            }
            else return (
                    <VisibilitySensor
                        onChange={(isVisible) => {buttonsAreVisibleCallback(isVisible)}}
                        partialVisibility={true}
                        active={chunk.id !== 'Choose a pill'}
                    >
                        <div dangerouslySetInnerHTML={{__html: chunk.cleanHTML}} id='activeChunk'/>
                    </VisibilitySensor>
                )
        }
        else {
            if (chunk.typing) {
                return <div dangerouslySetInnerHTML={{__html: chunk.processedHTML.body + buttonText}} />
            }
            else return <div dangerouslySetInnerHTML={{__html: chunk.cleanHTML + preResponse + buttonText}} />
        }
    }

    const chunkIsPrinted = () => {
        let answer = false
        if (showButtons && isActiveChunk) {
            answer = true
        }
        return answer
    }

    return (
        <div>
            {getAttachedComponent() && <br/>}
            {getAttachedComponent()}
            {getAttachedComponent() && <br/>}
            {getChunkOfText()}
            {isActiveChunk && !chunk.typing && !chunk.pause &&
                <Typewriter
                    onInit={(typewriter) => {
                        typewriter
                            .typeString("> ")
                            .start()
                        tw.onInit(typewriter)
                    }
                    }
                    options={tw.options}
                />
            }
            {chunkIsPrinted() &&
                <Grid container spacing={2} className={classes.buttonWrapper} id="buttons">
                    {getButtons()}
                </Grid>
            }
            {/*{chunkIsPrinted() &&*/}
            {/*    <TerminalLoginCTA logo={logo} progress={chunk.progress} chunkUid={chunk.uid} isRenegadeOS={chunk.isRenegadeOS}/>*/}
            {/*}*/}
        </div>
    )
}

export default ChunkDiv
